module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "layout-breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("基础信息")])]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("生产基础数据维护")])]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("缺陷代码维护")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-content"
  }, [_c('div', {
    staticClass: "layout-content-main"
  }, [_c('Form', {
    attrs: {
      "model": _vm.formBug,
      "label-width": 95
    }
  }, [_c('div', {
    staticClass: "formLine"
  }, [_c('FormItem', {
    staticClass: "mRight",
    attrs: {
      "label": "缺陷代码"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "缺陷代码"
    },
    model: {
      value: (_vm.formBug.bugCode),
      callback: function($$v) {
        _vm.$set(_vm.formBug, "bugCode", $$v)
      },
      expression: "formBug.bugCode"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticClass: "mRight",
    attrs: {
      "label": "缺陷名称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "缺陷名称"
    },
    model: {
      value: (_vm.formBug.bugName),
      callback: function($$v) {
        _vm.$set(_vm.formBug, "bugName", $$v)
      },
      expression: "formBug.bugName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticClass: "mRight",
    attrs: {
      "label": "缺陷大类代码"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "请选择缺陷大类代码查询"
    },
    on: {
      "on-change": this.searchCode
    },
    model: {
      value: (_vm.formBug.bigBug),
      callback: function($$v) {
        _vm.$set(_vm.formBug, "bigBug", $$v)
      },
      expression: "formBug.bigBug"
    }
  }, _vm._l((_vm.bigcode), function(value) {
    return _c('Option', {
      key: value.code,
      attrs: {
        "value": value.code
      }
    }, [_vm._v(_vm._s(value.code))])
  }))], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "缺陷大类名称"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "缺陷大类名称"
    },
    on: {
      "on-change": this.searchName
    },
    model: {
      value: (_vm.formBug.bigName),
      callback: function($$v) {
        _vm.$set(_vm.formBug, "bigName", $$v)
      },
      expression: "formBug.bigName"
    }
  }, _vm._l((_vm.bigcode), function(value) {
    return _c('Option', {
      key: value.value,
      attrs: {
        "value": value.value
      }
    }, [_vm._v(_vm._s(value.value))])
  }))], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "text-align": "center"
    }
  }, [_c('Button', {
    staticClass: "mRight mRight",
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": this.getResearch
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    staticClass: "mRight",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": this.addBug
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('Button', {
    staticClass: "mRight",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": this.editMaintain
    }
  }, [_vm._v("修改")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": this.del
    }
  }, [_vm._v("删除")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "table-wrapper"
  }, [_c('Table', {
    staticStyle: {
      "min-width": "700px"
    },
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.pageData.data
    },
    on: {
      "on-selection-change": _vm.getSelected
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.pageData.page.totalCount,
      "show-sizer": "",
      "show-elevator": "",
      "show-total": ""
    },
    on: {
      "on-change": _vm.onChange,
      "on-page-size-change": _vm.sizeChange
    }
  })], 1)])], 1)], 1)])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "mask-closable": false
    },
    model: {
      value: (_vm.addModal),
      callback: function($$v) {
        _vm.addModal = $$v
      },
      expression: "addModal"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.modelName))])], 1), _vm._v(" "), _c('Form', {
    attrs: {
      "model": _vm.addMaintain,
      "label-width": 100,
      "rules": _vm.ruleValidate
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "缺陷名称",
      "prop": "name"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.addMaintain.name),
      callback: function($$v) {
        _vm.$set(_vm.addMaintain, "name", $$v)
      },
      expression: "addMaintain.name"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "缺陷大类代码",
      "prop": "select"
    }
  }, [_c('Select', {
    attrs: {
      "label-in-value": true
    },
    on: {
      "on-change": this.changeBig
    },
    model: {
      value: (_vm.addMaintain.select),
      callback: function($$v) {
        _vm.$set(_vm.addMaintain, "select", $$v)
      },
      expression: "addMaintain.select"
    }
  }, _vm._l((_vm.bigcode), function(value) {
    return _c('Option', {
      key: value.value,
      attrs: {
        "value": value.value,
        "label": value.code
      }
    }, [_c('span', [_vm._v(_vm._s(value.code))]), _c('em', {
      staticClass: "fr"
    }, [_vm._v(_vm._s(value.value))])])
  }))], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "缺陷大类名称",
      "prop": "bigName"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.addMaintain.bigName),
      callback: function($$v) {
        _vm.$set(_vm.addMaintain, "bigName", $$v)
      },
      expression: "addMaintain.bigName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "是否使用",
      "prop": "ifuse"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.addMaintain.ifuse),
      callback: function($$v) {
        _vm.$set(_vm.addMaintain, "ifuse", $$v)
      },
      expression: "addMaintain.ifuse"
    }
  }, [_c('Radio', {
    class: [_vm.addMaintain.ifuse == '0' ? 'ivu-radio-checked' : ''],
    attrs: {
      "label": "0"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('Radio', {
    class: [_vm.addMaintain.ifuse == '1' ? 'ivu-radio-checked' : ''],
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "long": ""
    },
    on: {
      "click": function($event) {
        _vm.addData('addMaintain')
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "mask-closable": false
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.modelName))])], 1), _vm._v(" "), _c('Form', {
    attrs: {
      "model": _vm.maintain,
      "label-width": 100,
      "rules": _vm.ruleValidate2
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "缺陷名称",
      "prop": "name"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.maintain.name),
      callback: function($$v) {
        _vm.$set(_vm.maintain, "name", $$v)
      },
      expression: "maintain.name"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "缺陷大类代码",
      "prop": "select"
    }
  }, [_c('Select', {
    attrs: {
      "label-in-value": true
    },
    on: {
      "on-change": this.changeBig
    },
    model: {
      value: (_vm.maintain.select),
      callback: function($$v) {
        _vm.$set(_vm.maintain, "select", $$v)
      },
      expression: "maintain.select"
    }
  }, _vm._l((_vm.bigcode), function(value) {
    return _c('Option', {
      key: value.value,
      attrs: {
        "value": value.value,
        "label": value.code
      }
    }, [_c('span', [_vm._v(_vm._s(value.code))]), _c('em', {
      staticClass: "fr"
    }, [_vm._v(_vm._s(value.value))])])
  }))], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "缺陷大类名称",
      "prop": "bigName"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.maintain.bigName),
      callback: function($$v) {
        _vm.$set(_vm.maintain, "bigName", $$v)
      },
      expression: "maintain.bigName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "是否使用"
    }
  }, [_c('RadioGroup', {
    attrs: {
      "prop": "ifuse"
    },
    model: {
      value: (_vm.maintain.use),
      callback: function($$v) {
        _vm.$set(_vm.maintain, "use", $$v)
      },
      expression: "maintain.use"
    }
  }, [_c('Radio', {
    class: [_vm.maintain.use == '0' ? 'ivu-radio-checked' : ''],
    attrs: {
      "label": "0"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('Radio', {
    class: [_vm.maintain.use == '1' ? 'ivu-radio-checked' : ''],
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "long": ""
    },
    on: {
      "click": function($event) {
        _vm.submitData('maintain')
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ff085a3a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BaseManager/customer.vue
// module id = 946
// module chunks = 1